import { render, staticRenderFns } from "./CustomerInfoUpdate.vue?vue&type=template&id=d6a874b4&"
import script from "./CustomerInfoUpdate.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports